// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CalendarTwoToneSvg from "@fishx/icons-svg/es/asn/CalendarTwoTone";
import FishxIcon from '../components/FishxIcon';

var CalendarTwoTone = function CalendarTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CalendarTwoToneSvg
  }));
};

CalendarTwoTone.displayName = 'CalendarTwoTone';
export default React.forwardRef(CalendarTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CalendarTwoTone.js
// module id = 2147
// module chunks = 0